import { render, staticRenderFns } from "./DenunciasPage.vue?vue&type=template&id=1c6eca9e"
import script from "./DenunciasPage.vue?vue&type=script&lang=js"
export * from "./DenunciasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports